/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {GameBrandingImageInterface, GameBrandingInterface, GameInterface} from '@/store/modules/games/types';

const namespace: string = 'gamesStateModule';

/**
 * GamesNavigation component.
 *
 */

@Component({
    name: 'c-games-navigation',
})
export default class GamesNavigation extends Vue {
    // Games
    @Action('fetchGames', {namespace})
    public fetchGames: any;
    @Action('updateCurrentGame', {namespace})
    public updateCurrentGame: any;
    @Getter('getCurrentGame', {namespace})
    public getCurrentGame!: GameInterface;
    @Getter('getGames', {namespace})
    public getGames!: GameInterface[];
    // Settings masthead
    @Action('updateMastheadImage', {namespace: 'settingsModule'})
    public updateMastheadImage!: (imageSlug: string | undefined) => void;


    /**
     * Mounted life-cycle event.
     */
     public async mounted(): Promise<void> {
         await this.fetchGames();
    }

    /**
     * Select a game
     *
     * @param game
     */
    public selectGame(game: GameInterface): void {
        this.$router.push({name: 'reported-issues-game-slug', params: {gameSlug: game.slug}});
        this.updateCurrentGame(game);
        if (game.branding !== null && game.branding.key_art !== null) {
            this.updateMastheadImage(game.branding.key_art.url);
        }
    }

    /**
     * Get the background key art for a game
     */
    public getBackground(game: GameInterface): string {
        if (null == game.branding) {
            return '';
        }

        const branding: GameBrandingInterface = game.branding;

        if (null === branding.key_art) {
            return '';
        }

        return `background-image: url(${branding.key_art.url})`;
    }

    /**
     * Get the game logo
     */
    public getLogo(game: GameInterface): string {
        if (game.branding === null) {
            return '';
        }

        const branding: GameBrandingInterface = game.branding;

        if (branding.logo_white !== null) {
            return branding.logo_white.url;
        }

        if (branding.logo_colour !== null) {
            return branding.logo_colour.url;
        }

        return '';
    }
}
